export enum AMPLITUDE_EVENTS {
  LANDING_PAGE_EVENT = 'user.opened.acespace',
  PRICING_PAGE_EVENT = 'user.opened.pricingPage',
  APPOINTMENT_PAGE_EVENT = 'facility.refreshed.appointments',
  APPOINTMENT_MODAL_EVENT = 'facility.opened.modal',
  APPOINTMENT_MODAL_CREATE_EVENT = 'user.created.appointment',
  CLIENT_LIST_PAGE_EVENT = 'facility.refreshed.clientList',
  CLIENT_PROFILE_PAGE_EVENT = 'facility.opened.clientProfile',
  EMAIL_OUTREACH_PAGE_EVENT = 'facility.opened.emailOutreach',
  TEXT_OUTREACH_PAGE_EVENT = 'facility.opened.textOutreach',
  PROGRAMS_PAGE_EVENT = 'facility.opened.programs',
  WAIVERS_PAGE_EVENT = 'facility.opened.waivers',
  DISCARDED_APPOINTMENTS_PAGE_EVENT = 'facility.opened.discardedAppointments',
  OPERATIONS_PAGE_EVENT = 'facility.opened.operations',
}
